import {
  GET_USERS,
  GET_USER,
  SET_LOADING_USERS,
  USERS_ERROR,
  CLEAR_ERRORS_USERS,
  CLEAR_DATA_USERS
} from "../types";

export default (state, action) => {
  switch (action.type) {
    case GET_USERS:
      return {
        ...state,
        users: action.payload,
        errors: null,
        loading: false
      };
    case GET_USER:
      return {
        ...state,
        user: action.payload,
        loading: false
      };
    case SET_LOADING_USERS:
      return {
        ...state,
        loading: true
      };
    case USERS_ERROR:
      return {
        ...state,
        errors: action.payload,
        loading: false
      };
    case CLEAR_ERRORS_USERS:
      return {
        ...state,
        errors: null,
        loading: false
      };
    case CLEAR_DATA_USERS:
      return {
        ...state,
        users: [],
        user: {},
        loading: false,
        errors: null
      };
    default:
      return state;
  }
};
